module.exports = __webpack_public_path__ + "img/切割2.49365cac.svg";